module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(!_vm.c) ? _c('div', [_c('p', [_vm._v("Пропущен параметр \"c\"")])]) : _vm._e(), _vm._v(" "), (_vm.c === 'offer-list') ? _c('div', [_c('offer-list', {
    attrs: {
      "offers": _vm.offersList.offers,
      "initial-cart": _vm.initialCart
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.c === 'product-list') ? _c('div', [_c('product-list', {
    attrs: {
      "products": _vm.initialProducts
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.c === 'category-product-list') ? _c('div', [_vm._m(0), _vm._v(" "), _c('category-product-list', {
    attrs: {
      "base-url": _vm.baseUrl,
      "initial-filter": _vm.initialFilter,
      "filter-values": _vm.filterValues,
      "initial-products": _vm.initialProducts,
      "initial-count": _vm.initialCount,
      "initial-child-categories": _vm.childCategories,
      "initial-available-child-category-ids": _vm.availableChildCategoryIds,
      "initial-available-model-ids": _vm.availableModelIds,
      "initial-available-tag-ids": _vm.availableTagIds,
      "initial-models": _vm.models,
      "initial-tags": _vm.tags,
      "page-size": 6,
      "category": _vm.category
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.c === 'cart') ? _c('div', [_c('cart')], 1) : _vm._e(), _vm._v(" "), (_vm.c === 'order') ? _c('div', [_c('p', [_vm._v("Для формирования заказа надо заполнить корзину.")]), _vm._v(" "), _c('order')], 1) : _vm._e(), _vm._v(" "), (_vm.c === 'cart-info') ? _c('div', [_c('cart-info', {
    attrs: {
      "products": _vm.initialProducts
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "gl-breadcrumb breadcrumb"
  }, [_c('ul', [_c('li', [_c('a', [_vm._v("Bulma")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("Documentation")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("Components")])]), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('a', [_vm._v("Breadcrumb")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb7bfaa2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/site/Container.vue
// module id = 657
// module chunks = 2